import { render, staticRenderFns } from "./invoice-payment.vue?vue&type=template&id=66ad53f5&"
import script from "./invoice-payment.vue?vue&type=script&lang=js&"
export * from "./invoice-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports